import React from 'react';
import PropTypes from 'prop-types';
import { Block } from 'slate';
import classNames from 'classnames';
import getBlockClassName from '../../utils/getBlockClassName';

function OrderedListItem(props) {
  return React.createElement("div", Object.assign({
    className: classNames(getBlockClassName(props.node), 'slite-editor-list-item', 'slite-editor-list-item--ordered')
  }, props.attributes), props.children);
}

OrderedListItem.propTypes = {
  node: PropTypes.instanceOf(Block).isRequired,
  attributes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
};
export default OrderedListItem;